import { render, staticRenderFns } from "./QuizProperties.vue?vue&type=template&id=0c518bcd"
import script from "./QuizProperties.vue?vue&type=script&lang=js"
export * from "./QuizProperties.vue?vue&type=script&lang=js"
import style0 from "./QuizProperties.vue?vue&type=style&index=0&id=0c518bcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports